import { NgModule } from '@angular/core';
import { CommonModule, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { StartEntityRenewalComponent } from './start-entity-renewal/start-entity-renewal.component';
import { AuthGuard } from '../../shared/security/auth.guard';
import { InactiveOfficesEntityRenewalComponent } from './inactive-offices-entity-renewal/inactive-offices-entity-renewal.component';
import { QuestionnaireEntityRenewalComponent } from './questionnaire-entity-renewal/questionnaire-entity-renewal.component';
import { QuestionnaireVerifyEntityRenewalComponent } from './questionnaire-verify-entity-renewal/questionnaire-verify-entity-renewal.component';
import { CorporationEntityRenewalComponent } from './corporation-entity-renewal/corporation-entity-renewal.component';
import { ReviewEntityRenewalComponent } from './review-entity-renewal/review-entity-renewal.component';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { PipeModule } from '../../shared/pipes/pipe.module';
import { PTLSharedModule } from '../../shared/shared.module';
import { EntityRenewalService } from './entity-renewal.service';
import { RenewalReceiptComponent } from './renewal-receipt/renewal-receipt.component';
import { PaymentModule } from '../../shared/payment/payment.module';
import { RenewalPayComponent } from './renewal-pay/renewal-pay.component';
import { NgxPrintModule } from 'ngx-print';

const routes: Routes = [
  { path: 'startEntityRenewal', component: StartEntityRenewalComponent, canActivate: [AuthGuard]},
  { path: 'inactiveOfficesToRenew', component: InactiveOfficesEntityRenewalComponent, canActivate: [AuthGuard]},
  { path: 'entityRenewalQuestionnaire', component: QuestionnaireEntityRenewalComponent, canActivate: [AuthGuard]},
  { path: 'verifyEntityRenewalQuestionnaire', component: QuestionnaireVerifyEntityRenewalComponent, canActivate: [AuthGuard]},
  { path: 'entityCorporation', component: CorporationEntityRenewalComponent, canActivate: [AuthGuard]},
  { path: 'reviewEntityRenewal', component: ReviewEntityRenewalComponent, canActivate: [AuthGuard]},
  { path: 'renewalReceipt', component: RenewalReceiptComponent},
  { path: 'renewalPay', component: RenewalPayComponent, canActivate: [AuthGuard]},
 
  ];
  @NgModule({
    imports: [CommonModule,RouterModule.forChild(routes), FormsModule, PipeModule, PTLSharedModule , PaymentModule, NgxPrintModule],    
    declarations: [StartEntityRenewalComponent, InactiveOfficesEntityRenewalComponent, QuestionnaireEntityRenewalComponent, QuestionnaireVerifyEntityRenewalComponent, CorporationEntityRenewalComponent, ReviewEntityRenewalComponent, RenewalReceiptComponent, RenewalPayComponent],
    providers :[EntityRenewalService]
  })
export class EntityRenewalModule { }



// WEBPACK FOOTER //
// ./src/app/renewal/entity-renewal/entity-renewal.module.ts